import type { Tokens } from '../../../../theming/types'
import { styles } from '../../../../utilities'
import type { SelectionControlGroupProps } from '..'

export default (config: {
  props: Pick<SelectionControlGroupProps, 'disabled'> & { hideLegend?: boolean }
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    default: {
      fieldset: {
        border: 0,
        margin: 0,
        minWidth: 0,
        padding: '0.01em 0 0 0',
      },

      legend: {
        display: props.hideLegend ? 'block' : undefined,
        color: props.disabled
          ? tokens.formElementTextColorDisabled
          : tokens.fontColorDefault,

        ...(props.hideLegend && styles.visuallyHidden),
      },
    },

    hidden: styles.visuallyHidden,
  } as const
}
